import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);

const options = {
    plugins: {
        datalabels: {
            formatter: (value) => {
                if (value < 15) return '';
                return value;
            },
        },
        tooltip: {
            callbacks: {
                label: function (context) {
                    let label = context.label || '';
                    if (label) {
                        label += ': ';
                    }
                    if (context.parsed !== null) {
                        label += new Intl.NumberFormat('default', {
                            style: 'percent',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        }).format(context.parsed / 100);
                    }
                    return label;
                }
            }
        }
    },
    interaction: {
        mode: 'index',
        intersect: false,
    },
}
const Grafica = ({ valores = [], labels = [] }) => {
    const data = {
        labels: labels,
        datasets: [
            {
                label: 'Utilidad',
                data: valores,
                backgroundColor: [
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(224,176,255, 0.2 )',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(236, 223, 219, 0.2)',
                ],
                borderColor: [
                    'rgba(75, 192, 192, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(224,176,255, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 99, 132, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };

    return <Pie data={data} options={options} />
}
export default Grafica